import GeneralVideoAssetUploadJob from '@aytm/lib/AsyncJobManager/jobs/assets/VideoAssetUploadJob'
import AsyncJobManager from '@aytm/lib/AsyncJobManager/AsyncJobManager'

export const VideoAssetUploadManager = AsyncJobManager({ concurrency: 2 })

const config = {
  createAssetPath: null,
  templateID: null,
  srcSurveyID: null
}

export function configure({ createAssetPath, templateID, srcSurveyID } = {}) {
  config.createAssetPath = createAssetPath
  config.templateID = templateID
  config.srcSurveyID = srcSurveyID
}

export function VideoAssetUploadJob(file) {
  return config.createAssetPath
    ? GeneralVideoAssetUploadJob({
        createAssetPath: config.createAssetPath,
        file,
        params: { template_id: config.templateID, src_survey_id: config.srcSurveyID }
      })
    : Promise.reject(new Error('VideoAssetUploadManager - createAssetPath not configured'))
}

export default function upload(droppedFiles, onProgress) {
  const files = droppedFiles.slice(0, 100) // protect from mass upload
  return new Promise(resolve => {
    const uploadJobs = [...files].map(file => VideoAssetUploadJob(file))
    const fileTotalSizes = files.map(file => file.size || 0)
    const progress = {
      fileTotalSizes,
      fileLoadedSizes: Array.from({ length: files.length }),
      totalSize: fileTotalSizes.reduce((totalSize, fileSize) => totalSize + fileSize, 0),
      loadedSize: 0,
      totalFiles: files.length,
      loadedFiles: 0
    }
    VideoAssetUploadManager.queue(...uploadJobs).then(
      jobResults => {
        resolve(jobResults.map(result => ('done' === result.status ? result.result : null)).filter(x => x))
      },
      null,
      onProgress
        ? (type, fileIndex, loaded, total) => {
            // calculate progress
            switch (type) {
              case 'done': {
                progress.totalFiles = total
                progress.loadedFiles = loaded
                onProgress({
                  percents: Math.round((progress.loadedSize * 100) / progress.totalSize),
                  totalFiles: progress.totalFiles,
                  loadedFiles: progress.loadedFiles,
                  totalSize: progress.totalSize,
                  loadedSize: progress.loadedSize
                })
                break
              }
              case 'progress': {
                progress.fileLoadedSizes[fileIndex] = loaded
                progress.fileTotalSizes[fileIndex] = total
                progress.totalSize = progress.fileTotalSizes.reduce(
                  (fileSize, totalSize) => (totalSize ? fileSize + totalSize : fileSize),
                  0
                )
                progress.loadedSize = progress.fileLoadedSizes.reduce(
                  (loadedSize, fileLoadedSize) => (fileLoadedSize ? loadedSize + fileLoadedSize : loadedSize),
                  0
                )
                onProgress({
                  percents: Math.round((progress.loadedSize * 100) / progress.totalSize),
                  totalFiles: progress.totalFiles,
                  loadedFiles: progress.loadedFiles,
                  totalSize: progress.totalSize,
                  loadedSize: progress.loadedSize
                })
                break
              }
              default: {
                break
              }
            }
          }
        : null
    )
  })
}
